import React, { useState, useEffect } from 'react';
import { Calendar as BigCalendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './Timesheet.css';
import axios from 'axios';
import { useBootstrap } from './useBootstrap';
import Select from 'react-select';
import { FaCopy } from 'react-icons/fa'; // Import the copy icon
import api from '../services/api';
const localizer = momentLocalizer(moment);

// const taskOptionsStatic = [
//   // Scripting Tasks
//   { value: "scripting_questionnaire_review", label: "Scripting - Questionnaire Review" },
//   { value: "scripting_standard_templates", label: "Scripting - Standard Templates (includes template preparation, simple logics, variable naming, and test/live link creation)" },
//   { value: "scripting_scripting_logics", label: "Scripting - Scripting Logics (complex logics such as looping, max-diff, product rotation using external files)" },
//   { value: "scripting_updating_feedbacks", label: "Scripting - Updating Feedbacks (from researchers, co-scripters, etc.)" },
//   { value: "scripting_rework_1", label: "Scripting - Rework 1 (questionnaire revision, revised logics, issues from research)" },
//   { value: "scripting_rework_2", label: "Scripting - Rework 2 (issues from scripting)" },
//   { value: "scripting_follow_up", label: "Scripting - Follow-Up (technical challenges, discussions with S2C & S2G, platform issues)" },
//   { value: "scripting_others", label: "Scripting - Others" },

//   // Quality Checks
//   { value: "quality_checks_qc_survey", label: "Quality Checks - Survey QC" },
//   { value: "quality_checks_qc_co_scripter", label: "Quality Checks - Co-Scripter Survey QC" },
//   { value: "quality_checks_others", label: "Quality Checks - Others" },

//   // Raw Data Tasks
//   { value: "raw_data_extract_share", label: "Raw Data - Extract & Share with Researchers" },
//   { value: "raw_data_deletion", label: "Raw Data - Data Deletion (per QC report)" },
//   { value: "raw_data_checking", label: "Raw Data - Data Checking" },
//   { value: "raw_data_preparation", label: "Raw Data - Data Preparation (e.g., DPCX)" },
//   { value: "raw_data_merging", label: "Raw Data - Merging (syntax preparation, merging across platforms, tracker merging)" },
//   { value: "raw_data_others", label: "Raw Data - Others" },

//   // OE Data Tasks
//   { value: "oe_data_preparation", label: "OE Data - Preparation for Coding/Verbatim for Researchers" },
//   { value: "oe_data_conversion", label: "OE Data - Conversion to SPSS Format" },
//   { value: "oe_data_costing", label: "OE Data - Costing Calculation" },
//   { value: "oe_data_others", label: "OE Data - Others" },

//   // Database Tasks
//   { value: "database_cleaning", label: "Database - Cleaning (formatting, validating email links, etc.)" },
//   { value: "database_unique_links", label: "Database - Creating Unique Links" },
//   { value: "database_others", label: "Database - Others" },

//   // Quota Tasks
//   { value: "quota_setup", label: "Quota - Setup and Tracker Updates" },
//   { value: "quota_monitoring", label: "Quota - Monitoring & Quota Sheet Preparation" },
//   { value: "quota_rework_1", label: "Quota - Rework 1 (due to quota issues/multiple research versions)" },
//   { value: "quota_rework_2", label: "Quota - Rework 2 (due to scripting quota issues)" },
//   { value: "quota_others", label: "Quota - Others" },

//   // Dashboard Tasks
//   { value: "dashboard_hsbc", label: "Dashboard - HSBC Dashboards" },

//   // General Tasks
//   { value: "general_meeting_fun", label: "General - Meetings, Fun Activities, Celebrations, etc." },

//   // Upskilling
//   { value: "up_skilling_powerbi", label: "Upskilling - Power BI, Python, SPSS, Dimensions, etc." },
//   { value: "up_skilling_communication", label: "Upskilling - Communication Skills" },

//   // Email & Invitation Tasks
//   { value: "email_invitation_preparation", label: "Email Invitation Preparation" },

//   // Discussion Tasks
//   { value: "discussion_xebo", label: "Discussion with XEBO (regarding issues)" },

//   // Translations
//   { value: "scripting_translations", label: "Scripting - Translations" },

//   // Survey Launching
//   { value: "survey_launching", label: "Survey Launching Process" },

//   // Quota Issues Discussion
//   { value: "quota_issues", label: "Quota Issues (including discussions)" },

//   // Template & Logo Tasks
//   { value: "template_logos", label: "Template - Logos" },

//   // Shared Data
//   { value: "shared_sample_data", label: "Shared Sample Data" },

//   // Triggered Notifications
//   { value: "triggered_email_sms_reminders", label: "Triggered Email / SMS Reminders" },
//   { value: "sms_trigger", label: "SMS Trigger" },
//   { value: "email_trigger", label: "Email Trigger" },

//   // Logic Issues
//   { value: "logic_issues", label: "Logic Issues" },

//   // DP (Data Processing) Tasks
//   { value: "dp_analysis_plan_review", label: "DP - Analysis Plan Review" },
//   { value: "dp_questionnaire_review", label: "DP - Questionnaire Review" },
//   { value: "dp_template_editing", label: "DP - Template Editing" },
//   { value: "dp_template_tables_template_creation", label: "DP - Tables Template Creation" },
//   { value: "dp_template_banner_creation", label: "DP - Banner Creation" },
//   { value: "dp_template_weighting", label: "DP - Weighting" },
//   { value: "dp_template_oe_table_setup", label: "DP - OE Table Setup" },
//   { value: "dp_interim_data_tables_generates", label: "DP - Interim Data Tables Generation" },
//   { value: "dp_final_data_tables_generates", label: "DP - Final Data Tables Generation" },
//   { value: "dp_additional_request", label: "DP - Additional Request" },
//   { value: "dp_interim_tables_qc", label: "DP - Interim Tables QC" },
//   { value: "dp_final_tables_qc", label: "DP - Final Tables QC" },
//   { value: "dp_oe_data_qc", label: "DP - OE Data QC" },

//   // Status and Norms
//   { value: "status_update", label: "Status Update" },
//   { value: "norms", label: "Norms" },

//   // Stacked SPSS Tasks
//   { value: "stacked_spss_generates", label: "Stacked SPSS Generation" },
//   { value: "stacked_spss_qc", label: "Stacked SPSS QC" },

//   // SPSS Tasks
//   { value: "spss_data_preparation_regression", label: "SPSS - Data Preparation for Regression Analysis" },
//   { value: "spss_data_updates", label: "SPSS - Data Updates" },
//   { value: "spss_data_merging", label: "SPSS - Data Merging" },
//   { value: "spss_recode_cleaning_split", label: "SPSS - Recode, Cleaning, Split" },

//   // Not Applicable
//   { value: "na", label: "Not Applicable" }
// ];


const taskOptionsStatic = [
  // ---------------------------------------------------------------------------
  // I. PROJECT MANAGEMENT & COMMUNICATION
  // ---------------------------------------------------------------------------
  { value: "pm_comm_kick_off_briefing", label: "PM & Comm - Project Kick-off / Briefing Meetings (Internal/Client)" },
  { value: "pm_comm_internal_planning", label: "PM & Comm - Internal DP Team Planning & Strategy Meetings" },
  { value: "pm_comm_researcher_consultation", label: "PM & Comm - Ongoing Consultation with Researchers" },
  { value: "pm_comm_client_communication", label: "PM & Comm - Client Communication (Updates, Queries - if DP involved)" },
  { value: "pm_comm_vendor_liaison", label: "PM & Comm - Liaison with External Vendors (e.g., Panel, Translation, Coding)" },
  { value: "pm_comm_status_updates", label: "PM & Comm - Project Status Updates & Reporting" },
  { value: "pm_comm_problem_solving_escalation", label: "PM & Comm - Technical Problem Solving & Escalation Discussions" }, // Catches "Follow-Up", "Logic Issues Discussion"
  { value: "pm_comm_documentation", label: "PM & Comm - Project Documentation (Specs, Logs, Issue Tracking)" },


  { value: "datacorrect_error_identification_logging", label: "Data Correction - Error Identification & Logging (from QC, Researcher feedback)" },
  { value: "datacorrect_respondent_data_review", label: "Data Correction - Individual Respondent Data Review & Manual Edits" },
  { value: "datacorrect_logical_inconsistency_resolution", label: "Data Correction - Resolving Logical Inconsistencies & Contradictions" },
  { value: "datacorrect_data_imputation", label: "Data Correction - Data Imputation (if applicable & approved)" },
  { value: "datacorrect_verbatim_cleaning_standardization_oe", label: "Data Correction - Verbatim Cleaning/Standardization (OE Text)" },
  { value: "datacorrect_backcoding_oe", label: "Data Correction - Backcoding Open-Ends / 'Other Specify'" },
  { value: "datacorrect_syntax_based_correction", label: "Data Correction - Syntax-Based Correction Scripts (SPSS, R, Python)" },
  { value: "datacorrect_respondent_deletion_errors", label: "Data Correction - Respondent Deletion (based on identified data errors/QC)" }, // Moved from Raw Data
  { value: "datacorrect_correction_qc", label: "Data Correction - Quality Check of Applied Corrections" },
  { value: "datacorrect_documentation_changes", label: "Data Correction - Documenting All Data Changes & Corrections" },
  { value: "datacorrect_others", label: "Data Correction - Others" },
  // ---------------------------------------------------------------------------
  // II. QUESTIONNAIRE & ANALYSIS PLAN REVIEW (PRE-SCRIPTING)
  // ---------------------------------------------------------------------------
  { value: "qre_ap_questionnaire_review_dp", label: "QRE & AP - Questionnaire Review (DP Feasibility & Logic)" }, // Combines Scripting & DP Qre review
  { value: "qre_ap_analysis_plan_review", label: "QRE & AP - Analysis Plan / Tab Spec Review" },
  { value: "qre_ap_data_spec_clarification", label: "QRE & AP - Data Specification Clarification" },

  // ---------------------------------------------------------------------------
  // III. SURVEY SCRIPTING & SETUP
  // ---------------------------------------------------------------------------
  { value: "scripting_template_preparation", label: "Scripting - Standard Template Customization (Branding, Logos)" }, // Includes "Template - Logos"
  { value: "scripting_standard_programming", label: "Scripting - Standard Programming (Simple Logic, Variable Naming)" },
  { value: "scripting_complex_programming", label: "Scripting - Complex Programming (Looping, MaxDiff, Conjoint, Piping, Masking, Custom Validations)" },
  { value: "scripting_external_file_integration", label: "Scripting - External File Integration (Product Lists, Rotations)" },
  { value: "scripting_translation_implementation", label: "Scripting - Translation Implementation & Testing" },
  { value: "scripting_quota_module_setup", label: "Scripting - Quota Module Logic Setup in Survey" },
  { value: "scripting_feedback_updates", label: "Scripting - Implementing Feedback (Researcher, QC, Co-Scripter)" },
  { value: "scripting_rework_revisions", label: "Scripting - Rework / Revisions (Qre changes, Logic updates)" }, // Combines Rework 1 & 2
  { value: "scripting_test_live_link_generation", label: "Scripting - Test & Live Survey Link Generation" },
  { value: "scripting_platform_troubleshooting", label: "Scripting - Survey Platform Specific Troubleshooting/Workarounds" },
  { value: "scripting_others", label: "Scripting - Others" },

  // ---------------------------------------------------------------------------
  // IV. SCRIPTING & DATA QUALITY CHECKS (PRE-LAUNCH & IN-FIELD)
  // ---------------------------------------------------------------------------
  { value: "qc_script_self_test", label: "QC - Script Self-Testing / Dry Runs" },
  { value: "qc_script_peer_review", label: "QC - Co-Scripter / Peer Script Review" }, // Formerly "Co-Scripter Survey QC"
  { value: "qc_script_researcher_pilot_feedback", label: "QC - Incorporating Researcher Pilot Feedback" },
  { value: "qc_live_data_initial_checks", label: "QC - Initial Live Data Checks (Soft Launch)" },
  { value: "qc_data_quality_monitoring_infield", label: "QC - In-field Data Quality Monitoring (Speeders, Flatliners)" },
  { value: "qc_others", label: "QC - Others" },

  // ---------------------------------------------------------------------------
  // V. SAMPLE MANAGEMENT & FIELDWORK SUPPORT
  // ---------------------------------------------------------------------------
  { value: "sample_db_cleaning_formatting", label: "Sample Mgt - Database Cleaning & Formatting (Contacts, Emails)" },
  { value: "sample_db_unique_link_generation", label: "Sample Mgt - Unique Survey Link Generation for Sample" },
  { value: "sample_invitation_email_sms_prep", label: "Sample Mgt - Email/SMS Invitation & Reminder Preparation/Setup" }, // Combines "Email Invitation Preparation", "Triggered Email / SMS Reminders"
  { value: "sample_shared_data_prep", label: "Sample Mgt - Shared Sample Data Preparation/Handling" },
  { value: "quota_setup_field", label: "Quota Mgt - Field Quota Setup & Tracker Updates (Platform/Manual)" },
  { value: "quota_monitoring_management", label: "Quota Mgt - Quota Monitoring, Reporting & Adjustment" }, // Includes "Quota Sheet Preparation"
  { value: "quota_issue_resolution", label: "Quota Mgt - Quota Issue Investigation & Resolution" }, // Combines "Rework 1 & 2" and "Quota Issues"
  { value: "survey_launch_coordination", label: "Field Support - Survey Launch Coordination & Go-Live Checks" }, // "Survey Launching Process"
  { value: "field_technical_support", label: "Field Support - Addressing Technical Issues During Fieldwork" },
  { value: "sample_others", label: "Sample Mgt - Others" },
  { value: "quota_others", label: "Quota Mgt - Others" },

  // ---------------------------------------------------------------------------
  // VI. RAW DATA MANAGEMENT & PREPARATION
  // ---------------------------------------------------------------------------
  { value: "rawdata_extraction_delivery", label: "Raw Data - Extraction & Initial Delivery to Researchers" },
  { value: "rawdata_cleaning_validation", label: "Raw Data - Cleaning & Validation (Logic checks, Outliers, Duplicates)" }, // Enhanced "Data Checking"
  { value: "rawdata_deletion_qc_report", label: "Raw Data - Respondent Deletion (per QC/Client instructions)" },
  { value: "rawdata_oe_preparation_coding", label: "Raw Data - OE Preparation for Coding (Export/Formatting)" }, // "OE Data - Preparation for Coding/Verbatim"
  { value: "rawdata_coded_oe_integration", label: "Raw Data - Integrating Coded OE Data back into Main Dataset" },
  { value: "rawdata_merging_datasets", label: "Raw Data - Merging Datasets (Trackers, Multiple sources/platforms)" },
  { value: "rawdata_transformation_recoding", label: "Raw Data - Data Transformation (Recoding, Variable Derivation)" },
  { value: "rawdata_formatting_spss_other", label: "Raw Data - Formatting for SPSS/Other Analysis Software" }, // Includes "OE Data - Conversion to SPSS Format"
  { value: "rawdata_weighting_preparation", label: "Raw Data - Data Preparation for Weighting" },
  { value: "rawdata_costing_oe_translation", label: "Raw Data - Costing Calculation (OE Coding, Translation)" }, // "OE Data - Costing Calculation"
  { value: "rawdata_others", label: "Raw Data - Others" },
  { value: "oe_data_others", label: "OE Data - Others (specific to OE if not covered)" }, // Kept if OE has distinct tasks not covered.
  { value: "database_others", label: "Database Tasks - Others (if not sample related)" }, // Kept for non-sample DB tasks.
  { value: "excel_to_spss", label: "Excel to SPSS data converstion / Syntax writing" }, // Kept for non-sample DB tasks.

  // ---------------------------------------------------------------------------
  // VII. DATA PROCESSING & TABULATION
  // ---------------------------------------------------------------------------
  { value: "dp_tab_spec_finalization", label: "DP - Tabulation Spec Finalization/Creation" }, // "Analysis Plan Review" is earlier, this is about the spec itself
  { value: "dp_table_template_setup", label: "DP - Table Template Setup (Shells, Banners, Nets)" }, // Combines "Template Editing", "Tables Template Creation", "Banner Creation"
  { value: "dp_weighting_application_qc", label: "DP - Weighting Scheme Application & QC" }, // "Weighting"
  { value: "dp_oe_table_setup", label: "DP - OE Table Setup in Tables" },
  { value: "dp_interim_tables_generation", label: "DP - Interim Table Generation" },
  { value: "dp_final_tables_generation", label: "DP - Final Table Generation" },
  { value: "dp_statistical_testing_setup", label: "DP - Statistical Testing Setup in Tables (Sig-testing)" },
  { value: "dp_chart_table_preparation", label: "DP - Chart Table Preparation" },
  { value: "dp_data_for_advanced_analytics", label: "DP - Data Preparation for Advanced Analytics (Regression, Segmentation)" }, // "SPSS - Data Preparation for Regression Analysis"
  { value: "dp_spss_stacked_file_generation", label: "DP - SPSS/Stacked Data File Generation" }, // "Stacked SPSS Generation"
  { value: "dp_norms_database_update", label: "DP - Norms Database Calculation & Update" }, // "Norms"
  { value: "dp_additional_requests_reruns", label: "DP - Additional Table Requests / Re-runs" },
  { value: "dp_others", label: "DP - Others" },

  // ---------------------------------------------------------------------------
  // VIII. DP QUALITY CONTROL (POST-FIELD)
  // ---------------------------------------------------------------------------
  { value: "qc_dp_raw_data_final_check", label: "QC (DP) - Final Raw Data Validation (Pre-tabulation)" },
  { value: "qc_dp_weighting_accuracy", label: "QC (DP) - Weighting Scheme Accuracy Check" },
  { value: "qc_dp_interim_tables", label: "QC (DP) - Interim Table QC (Counts, Bases, Logic)" },
  { value: "qc_dp_final_tables", label: "QC (DP) - Final Table QC (Counts, Bases, Logic, Formatting)" },
  { value: "qc_dp_spss_stacked_file", label: "QC (DP) - SPSS/Stacked Data File QC" }, // "Stacked SPSS QC"
  { value: "qc_dp_oe_data_final", label: "QC (DP) - Final Coded OE Data QC" }, // "DP - OE Data QC"
  { value: "qc_dp_chart_data_accuracy", label: "QC (DP) - Chart Data Accuracy Check" },
  { value: "qc_dp_dashboard_data_accuracy", label: "QC (DP) - Dashboard Data Accuracy Check" },

  // ---------------------------------------------------------------------------
  // IX. DELIVERABLES & REPORTING SUPPORT
  // ---------------------------------------------------------------------------
  { value: "deliverable_dashboard_creation_update", label: "Deliverable - Dashboard Creation/Update (e.g., PowerBI, Tableau, Specific Client Dashboards like HSBC)" }, // "Dashboard - HSBC"
  { value: "deliverable_chart_material_prep", label: "Deliverable - Chart Material Preparation for Reports" },
  { value: "deliverable_final_data_export_formats", label: "Deliverable - Final Data Export in Various Formats (SPSS, Excel, CSV)" },
  { value: "deliverable_report_automation_support", label: "Deliverable - Report Automation Support" },
  { value: "deliverable_archiving", label: "Deliverable - Project Data & Document Archiving" },

  // ---------------------------------------------------------------------------
  // X. GENERAL & ADMINISTRATIVE
  // ---------------------------------------------------------------------------
  { value: "general_team_meetings_activities", label: "General - Team Meetings, Fun Activities, Celebrations" },
  { value: "general_admin_timesheets", label: "General - Administrative Tasks (Timesheets, etc.)" },
  { value: "general_process_improvement_initiatives", label: "General - Process Improvement Initiatives & Discussions" },
  { value: "general_tool_evaluation_testing", label: "General - New Tool/Software Evaluation & Testing" },
  { value: "general_knowledge_sharing_sessions", label: "General - Internal Knowledge Sharing Sessions" },

  // ---------------------------------------------------------------------------
  // XI. UPSKILLING & TRAINING
  // ---------------------------------------------------------------------------
  { value: "training_technical_skills", label: "Upskilling - Technical Skills (Power BI, Python, SPSS, Dimensions, New Platforms)" },
  { value: "training_soft_skills", label: "Upskilling - Soft Skills (Communication, Presentation, Project Management)" },
  { value: "training_new_methodologies", label: "Upskilling - Learning New Research Methodologies & DP Implications" },
  { value: "training_onboarding_new_staff", label: "Upskilling - Onboarding/Training New Team Members" },

  // ---------------------------------------------------------------------------
  // XII. MISCELLANEOUS / OTHER
  // ---------------------------------------------------------------------------
  { value: "other_unspecified_task", label: "Other - Unspecified Task (Please specify)" },
  { value: "na_not_applicable", label: "Not Applicable" }
];

// For reference, these were some of your less categorized items that got integrated:
// { value: "discussion_xebo", label: "Discussion with XEBO (regarding issues)" }, // -> pm_comm_vendor_liaison or pm_comm_problem_solving_escalation
// { value: "logic_issues", label: "Logic Issues" }, // -> scripting_rework_revisions or pm_comm_problem_solving_escalation
// { value: "spss_data_updates", label: "SPSS - Data Updates" }, // -> rawdata_transformation_recoding or part of dp_additional_requests_reruns
// { value: "spss_data_merging", label: "SPSS - Data Merging" }, // -> rawdata_merging_datasets
// { value: "spss_recode_cleaning_split", label: "SPSS - Recode, Cleaning, Split" }, // -> rawdata_transformation_recoding and rawdata_cleaning_validation

function Timesheet() {
  useBootstrap();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [refreshEvents, setRefreshEvents] = useState(false);
  const [events, setEvents] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedDates, setSelectedDates] = useState([]);
  const [selectedTimeSlots, setSelectedTimeSlots] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [projectOptions, setProjectOptions] = useState([]);
  const [selectedProject, setSelectedProject] = useState('');
  const [selectedTask, setSelectedTask] = useState('');

  // Fetch project options on component mount
  useEffect(() => {
    const token = localStorage.getItem("Token");

    api
      .get('api/segments/unique_segments_with_job/', {
        headers: {
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (response.data.unique_segment_names?.length > 0) {
          const validSegments = response.data.unique_segment_names.filter(
            (name) => name !== null && name.trim() !== ""
          );
          setProjectOptions(validSegments);
        } else {
          console.error("No unique segment names found");
          setProjectOptions([]);
        }
      })
      .catch((error) => console.error('Error fetching unique segment names:', error));
  }, []);

  // Function to extract the content from the table with id 'summary-table'
  const getTableContent = () => {
    const table = document.getElementById('summary-table');
    if (!table) {
      return "No summary table found.";
    }
    let tableContent = '';
    for (let row of table.rows) {
      for (let cell of row.cells) {
        tableContent += cell.innerText + '\t';
      }
      tableContent += '\n';
    }
    return tableContent;
  };

  // Function to handle copying the summary table to clipboard
  const handleCopySummary = () => {
    const content = getTableContent();
    navigator.clipboard.writeText(content)
      .then(() => {
        alert("Today's summary table copied to clipboard!");
      })
      .catch((error) => {
        console.error("Failed to copy summary:", error);
        alert("Failed to copy summary. Please try again.");
      });
  };

  const handleSelectSlot = ({ start, end }) => {
    const startLocal = moment(start).local();
    const endLocal = moment(end).local();

    const dates = [];
    const times = [];
    
    let currentDate = startLocal.clone();
    while (currentDate <= endLocal) {
      dates.push(currentDate.clone());
      currentDate.add(1, 'day');
    }
    setSelectedDates(dates);

    let currentTime = startLocal.clone();
    while (currentTime < endLocal) {
      times.push({
        start: currentTime.clone(),
        end: currentTime.clone().add(30, 'minutes'),
      });
      currentTime.add(30, 'minutes');
    }
    setSelectedTimeSlots(times);
    setShowAddModal(true);
  };

  const handleAddModalClose = () => {
    setShowAddModal(false);
    setSelectedDates([]);
    setSelectedTimeSlots([]);
    setSelectedProject('');
    setSelectedTask('');
    setRefreshEvents((prev) => !prev);
  };

  useEffect(() => {
    const token = localStorage.getItem("Token");

    api
      .get("timesheet/api/events/", {
        headers: {
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (response.data.length > 0) {
          let cumulativeSum = 0;
          const formattedEvents = response.data.flatMap((event) =>
            event.time_slots.map((slot) => {
              const duration = moment.utc(slot.end_time).diff(moment.utc(slot.start_time), "minutes");
              cumulativeSum += duration;
              return {
                id: event.id,
                title: `${event.project || ""}${event.task ? ", " + event.task : ""}`,
                start: moment.utc(slot.start_time).local().toDate(),
                end: moment.utc(slot.end_time).local().toDate(),
                cumulativeSum,
              };
            })
          );
          setEvents(formattedEvents);
        } else {
          console.warn("No events found");
        }
      })
      .catch((error) => console.error("Error fetching events:", error));
  }, [refreshEvents]);

   const handleAddModalSubmit = () => {
    // Validation for selectedProject (which is now an object or null)
    if (!selectedProject || !selectedProject.value) { // Check for object and its value property
      alert("Please select a project!");
      return;
    }
    // Validation for selectedTask (assuming it's also a react-select object or null)
    if (!selectedTask || !selectedTask.value) { // Check for object and its value property
      alert("Please select a task!");
      return;
    }
    if (selectedDates.length === 0 || selectedTimeSlots.length === 0) {
      alert("Please select at least one date and time slot!");
      return;
    }

    const token = localStorage.getItem("Token");
    if (!token) {
      console.error("Token not found");
      return;
    }

    // --- FIX IS HERE ---
    const projectString = selectedProject.value; // Extract the string value
    const taskString = selectedTask.label;     // Extract the string value

    const timeSlots = selectedTimeSlots.map((slot) => ({
      start_time: slot.start.toISOString(),
      end_time: slot.end.toISOString(),
    }));

    api
      .post(
        "timesheet/api/events/",
        {
          project: projectString, // Send the string value
          task: taskString,     // Send the string value
          start_date: moment(selectedDates[0]).format("YYYY-MM-DD"),
          end_date: moment(selectedDates[selectedDates.length - 1]).format(
            "YYYY-MM-DD"
          ),
          time_slots: timeSlots,
        },
        {
          headers: {
            Authorization: `Token ${token}`,
          },
        }
      )
      .then((response) => {
        if (response.data && response.data.id) {
          // When creating title for new events, use the string values too
          const newEvents = timeSlots.map((slot) => ({
            id: response.data.id,
            title: `${projectString || ""}${taskString ? ", " + taskString : ""}`, // Use string values
            start: moment.utc(slot.start_time).local().toDate(),
            end: moment.utc(slot.end_time).local().toDate(),
          }));

          // Grouping logic seems okay, but ensure title consistency if you re-fetch vs. optimistic update
          const groupedEvents = newEvents.reduce((acc, event) => {
            if (!acc[event.title]) {
              acc[event.title] = [];
            }
            acc[event.title].push(event);
            return acc;
          }, {});

          setEvents((prevEvents) => {
            // This optimistic update logic might become complex if titles don't exactly match
            // what the server would return if you re-fetched.
            // Consider simply re-fetching for simplicity if optimistic update becomes tricky.
            // For now, let's assume it works:
            const groupedPrevEvents = prevEvents.reduce((acc, event) => {
              if (!acc[event.title]) {
                acc[event.title] = [];
              }
              acc[event.title].push(event);
              return acc;
            }, {});
            return [
              ...Object.values(groupedPrevEvents).flat(),
              ...Object.values(groupedEvents).flat(),
            ];
          });
        } else {
          console.error("Failed to create event: Invalid response", response);
        }
        handleAddModalClose(); // This also resets selectedProject and selectedTask
      })
      .catch((error) => {
        console.error("Error creating event:", error.response?.data || error.message || error);
        alert( error.response?.data?.project?.[0] || error.response?.data?.task?.[0] || "There was an error creating the event. Please try again.");
      });
  };

  const [deletedEvent, setDeletedEvent] = useState(null);

  const handleDeleteEvent = () => {
    const eventToDelete = selectedEvent;

    api
      .delete(`timesheet/api/events/${eventToDelete.id}/`, {
        headers: {
          Authorization: `Token ${localStorage.getItem("Token")}`,
        },
      })
      .then(() => {
        setDeletedEvent(eventToDelete);
        setEvents((prevEvents) => prevEvents.filter((event) => event.id !== eventToDelete.id));
        setRefreshEvents((prev) => !prev);
      })
      .catch((error) => {
        console.error("Error deleting event:", error);
        alert("Failed to delete event. Please try again.");
      });
  };

  // Undo deletion
  const handleUndoDelete = () => {
    if (deletedEvent) {
      api
        .post(
          "timesheet/api/events/",
          {
            project: deletedEvent.project,
            task: deletedEvent.task,
            start_date: moment(deletedEvent.start).format("YYYY-MM-DD"),
            end_date: moment(deletedEvent.end).format("YYYY-MM-DD"),
            time_slots: [
              {
                start_time: moment(deletedEvent.start).toISOString(),
                end_time: moment(deletedEvent.end).toISOString(),
              },
            ],
          },
          {
            headers: {
              Authorization: `Token ${localStorage.getItem("Token")}`,
            },
          }
        )
        .then((response) => {
          setEvents((prevEvents) => [...prevEvents, response.data]);
          setDeletedEvent(null);
          alert("Event restored successfully.");
        })
        .catch((error) => {
          console.error("Error restoring event:", error);
          alert("Failed to restore event. Please try again.");
        });
    }
  };

  const getReactSelectProjectOptions = (options) => {
  const mappedOptions = options.map(option => ({ value: option, label: option }));
  // Ensure "Others" is always an option if not already present
  if (!options.includes("Others")) {
    mappedOptions.push({ value: "Others", label: "Others" });
  }
  return mappedOptions;
};
const handleProjectChange = (selectedOption) => {
  setSelectedProject(selectedOption); // selectedOption will be { value: 'Project A', label: 'Project A' } or null
};

  const handleChange = (selectedOption) => {
    setSelectedTask(selectedOption);
  };

  const handleEventClick = (event) => {
    setSelectedEvent(event);
    const [project, task] = event.title.split(', ');
    setSelectedProject(project || '');
    setSelectedTask(task || '');
    setShowEditModal(true);
  };

  const handleEditModalClose = () => {
    setShowEditModal(false);
    setSelectedEvent(null);
    setSelectedProject('');
    setSelectedTask('');
  };

  return (
    <div className="timesheet-container">
      <div style={{ padding: '5px 20px 10px 40px', height: '100vh' }}>
        {/* Copy Summary Button with Icon */}
        {/* <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
          <button className="btn btn-primary" onClick={handleCopySummary} style={{ display: 'flex', alignItems: 'center' }}>
            <FaCopy style={{ marginRight: '5px' }} />
            Copy Today's Summary Table
          </button>
        </div> */}

        <BigCalendar
          localizer={localizer}
          events={events}
          startAccessor="start"
          endAccessor="end"
          defaultView="day"
          selectable
          onSelectSlot={handleSelectSlot}
          onSelectEvent={handleEventClick}
          step={30}
          timeslots={1}
          components={{
            agenda: {
              event: ({ event }) => (
                <span>
                  {event.title} - {event.cumulativeSum} mins
                </span>
              ),
            },
          }}
        />

        {/* Add Modal */}
        {showAddModal && (
  <div className="modal show d-block" tabIndex="-1" role="dialog">
    <div className="modal-dialog" role="document" style={{ marginTop: '150px' }}>
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Add New Event</h5>
          <button type="button" className="close" aria-label="Close" onClick={handleAddModalClose}>
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          <label htmlFor="project-select">Project Name:</label> {/* Added htmlFor for accessibility */}
          <Select
            id="project-select" // Added id for accessibility
            className="mb-2"
            value={selectedProject} // react-select expects the selected option object or null
            onChange={handleProjectChange}
            options={getReactSelectProjectOptions(projectOptions)}
            placeholder="Search or Select Project"
            isSearchable
            isClearable // Optional: Allows clearing the selection
            noOptionsMessage={() => projectOptions.length === 0 ? "No Projects Available (except Others)" : "No matching projects (except Others)"}
          />

          <label htmlFor="task-select">Task Name:</label> {/* Added htmlFor for accessibility */}
          <Select
            id="task-select" // Added id for accessibility
            className="mb-2"
            value={selectedTask}
            onChange={handleChange} // Your existing handleChange for tasks
            options={taskOptionsStatic}
            placeholder="Search or Select Task"
            isSearchable
            isClearable // Optional
          />
        </div>
        <div className="modal-footer">
          <button 
            type="button" 
            className="btn btn-success" 
            onClick={handleAddModalSubmit}
            // Disable button if project or task is not selected
            disabled={!selectedProject || !selectedTask} 
          >
            Create Event
          </button>
          <button type="button" className="btn btn-danger" onClick={handleAddModalClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
)}

        {/* Edit Modal */}
        {showEditModal && (
          <div className="modal show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog" role="document" style={{ marginTop: '150px' }}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Delete Event</h5>
                  <button type="button" className="close" aria-label="Close" onClick={handleEditModalClose}>
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => setShowDeleteModal(true)}
                  >
                    Delete Event
                  </button>
                  <button type="button" className="btn btn-secondary" onClick={handleEditModalClose}>
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Delete Confirmation Modal */}
        {showDeleteModal && (
          <div className="modal show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog" role="document" style={{ marginTop: '150px' }}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Confirm Delete</h5>
                  <button
                    type="button"
                    className="close"
                    aria-label="Close"
                    onClick={() => setShowDeleteModal(false)}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <p>Are you sure you want to delete this event? This action cannot be undone.</p>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => {
                      handleDeleteEvent();
                      setShowDeleteModal(false);
                      setShowEditModal(false);
                    }}
                  >
                    Confirm Delete
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowDeleteModal(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Timesheet;
